import { z } from "zod";

export const defaultToolId = "Github.SetStarred";
export const defaultInput = {
  owner: "arcadeai",
  name: "arcade-mcp",
  starred: "true",
};

// Input keys fill parameters by name, so only the example tool starts prefilled.
export const executeSearchSchema = z
  .object({
    // A missing toolId gets the default; a malformed one is cleared, not defaulted.
    toolId: z.string().catch("").default(defaultToolId),
    input: z.record(z.string(), z.string()).catch({}).optional(),
  })
  .transform(({ toolId, input }) => ({
    toolId,
    input: input ?? (toolId === defaultToolId ? defaultInput : {}),
  }));
